import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Formik } from 'formik';
import { RepliconDialog } from '~/modules/common/components';
import { PERIOD_SCALE_ENUM } from '~/modules/resourcing/common/enums';
import SetResourceAllocationDialogTitle from './SetResourceAllocationDialogTitle';
import SetResourceAllocationDialogContent from './SetResourceAllocationDialogContent';
import SetResourceAllocationDialogFooter from './SetResourceAllocationDialogFooter';
import { useSetResourceAllocationFormState } from './hooks/useSetResourceAllocationFormState';

const SetResourceAllocationDialogTitleId =
  'set-resource-allocation-dialog-title';

const SetResourceAllocationDialog = ({
  onClose,
  open,
  project,
  scale,
  user
}) => {
  const {
    initialValues,
    validationSchema
  } = useSetResourceAllocationFormState({ project, scale });
  const [isFormDirty, setIsFormDirty] = useState(false);

  const checkIsDirty = useCallback(() => isFormDirty, [isFormDirty]);

  return (
    <RepliconDialog
      aria-labelledby={SetResourceAllocationDialogTitleId}
      checkIsDirty={checkIsDirty}
      data-qe-id="SetResourceAllocationDialog"
      enableUnsavedChangesWarning
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      trapFocusWithDatePicker
    >
      <SetResourceAllocationDialogTitle
        project={project}
        titleId={SetResourceAllocationDialogTitleId}
        user={user}
      />
      <Formik
        initialValues={initialValues}
        onSubmit={() => {}} // TODO
        validationSchema={validationSchema}
      >
        <>
          <SetResourceAllocationDialogContent setIsFormDirty={setIsFormDirty} />
          <SetResourceAllocationDialogFooter onClose={onClose} />
        </>
      </Formik>
    </RepliconDialog>
  );
};

SetResourceAllocationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)).isRequired,
  user: PropTypes.object
};

export default SetResourceAllocationDialog;
